import { useContext } from "react";
import { LocaleChoiceContext, useT } from "../i18n/context";
import { availableLocales } from "../i18n/index";
import { Choice } from "./Choices";

/**
 * The language, picked by hand (review 0021 decision 133): each language names itself; the choice
 * stays on this device. Arabic is offered only while its flag allows (decision 138).
 */
export function LanguagePicker() {
  const { t, locale } = useT();
  const choose = useContext(LocaleChoiceContext);
  return (
    <fieldset className="m-0 flex flex-wrap gap-2 border-0 p-0">
      <legend className="sr-only">{t("language.title")}</legend>
      {availableLocales().map((option) => (
        <Choice
          key={option}
          label={t(`language.${option}`)}
          selected={option === locale}
          onClick={() => choose(option)}
        />
      ))}
    </fieldset>
  );
}
